import React from "react";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import ArticleListItem from "../ArticleListItem/ArticleListItem";
import "./ArticleList.css";

class ArticleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { currentListCount: 0, renderingID: 0 };
  }

  componentDidMount() {
    this.recursive(this.state.renderingID);
  }

  recursive(renderingID) {
    setTimeout(() => {
      if (this.state.renderingID !== renderingID) {
        return;
      }

      this.setState({
        currentListCount: this.state.currentListCount + 3
      });

      if (this.state.currentListCount < this.props.articleIDs.length) {
        this.recursive(renderingID);
      }
    }, 0);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.articleIDs !== state.prevArticleIDs) {
      return {
        currentListCount: 0,
        renderingID: state.renderingID + 1,
        prevArticleIDs: props.articleIDs
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.articleIDs !== prevProps.articleIDs) {
      this.recursive(this.state.renderingID);
    }
  }

  render() {
    const {
      isLoading,
      articleIDs,
      errMsg,
      updateAnArticleMetaAction,
      isPdf,
      isAdmin,
      articlesDict,
      issueID
    } = this.props;

    if (isLoading) {
      return (
        <div className="article_spinner_container">
          <Spinner animation="grow" />
        </div>
      );
    } else if (errMsg != null) {
      return (
        <div className="article_error_container">
          <Alert variant="danger">{errMsg}</Alert>
        </div>
      );
    } else {
      const renderingFilteredList = articleIDs.slice(
        0,
        this.state.currentListCount + 1
      );

      return (
        <React.Fragment>
          {renderingFilteredList.map((articleID, idx) => (
            <ArticleListItem
              issueID={issueID}
              isPdf={isPdf}
              isAdmin={isAdmin}
              idx={idx + 1}
              article={articlesDict[articleID]}
              key={articleID}
              updateAnArticleMetaAction={updateAnArticleMetaAction}
            />
          ))}
        </React.Fragment>
      );
    }
  }
}

export default ArticleList;
